export default __webpack_public_path__ + "static/media/diamond-cut-5@3x.e8814425.png";